
import {Component, Mixins, Watch, Prop, Ref} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import AlacakTuruPicker from "@/components/pickers/AlacakTuruPicker.vue";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";
import {ParaBirimi} from "@/enum/ParaBirimi";
import Faizler from "@/components/forms/Faizler.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import {AlacakKalemiTuru} from "@/enum/AlacakKalemiTuru";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import Kur from "@/components/inputs/Kur.vue";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import {alacakKurunuEsitle} from "@/helpers/TakipTarihliKurHelper";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {TakipTipi} from "@/enum/TakipTipi";
import {NakakaEnum} from "@/enum/NafakaEnum";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";
import {nafakaTutarlariniFormaAyir} from "@/helpers/NafakaTutarHelper";


@Component({
  components: {
    Kur,
    ParaBirimiPicker,
    AlacakTuruPicker,
    Tutar,
    Dates,
    Faizler,
    FormWrapper,
    DovizTakipSekliPicker
  },
})
export default class NafakaAlacakKalemiForm extends Mixins(ObjectInputMixin) {
  @Prop() hideButtons!: boolean | string;
  @Prop() takipTipiId!: number;
  @Prop() alacak!: AlacakEntity;
  @Ref('form') readonly form!: FormWrapper;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop({default: false}) defaultFirstItem!: boolean;

  readonlyParaBirimi = false;
  kurElleDegisti = false; // Kur kutusuna kullanıcı yazdı mı: alacak ekranına yansıtma buna bağlı
  paraBirimi = ParaBirimi;
  AlacakBelgeTuru = AlacakBelgeTuru;
  AlacakKalemiTuru = AlacakKalemiTuru;
  AlacakKalemiAlani = AlacakKalemiAlani;
  dovizTakipSekli = DovizTakipSekli;
  NakakaEnum = NakakaEnum;
  paraBirimleri:Array<ParaBirimi>=[]
  showConfirmDialog: boolean = false;
  devamEdenAylarIcinGecerli: boolean = true;
  // Onay dialogu AYLIK tutarın değişimini izler ("devam eden aylar için de bu tutar geçerli
  // olsun"). Talep edilen tutar (= `tutar`, takip tabanı) değişince dialog açılmaz; yeniden
  // hesap backend'de kendiliğinden tetiklenir.
  originalAylikTutar: any = null;

  get showOzneBilgileri(): boolean {
    const turuId = this.localValue.alacak_kalemi_turu_id;
    return turuId === NakakaEnum.istirak_nafakasi || turuId === NakakaEnum.yoksulluk_nafakasi;
  }

  get ozneBilgileriLabel(): string {
    const turuId = this.localValue.alacak_kalemi_turu_id;
    if (turuId === NakakaEnum.yoksulluk_nafakasi) {
      return 'Eşin Adı';
    }
    if (turuId === NakakaEnum.istirak_nafakasi) {
      return 'Çocuğun Adı';
    }
    return '';
  }

  async save(){
    if (this.alacak.id){
      this.localValue.alacak_id = this.alacak.id

      if (!this.localValue.id) {
        this.localValue.alacak_kalemi_alani_id = AlacakKalemiAlani.asilAlacak
      }

      if (this.alacak.alacak_belge_turu_id !== this.AlacakBelgeTuru.apartman_alacagi){
        this.localValue.gecikme_tazminati_mi = false
      }else{
        if (this.localValue.gecikme_tazminati_mi){
          this.localValue.gecikme_tazminati_mi = true
        }else{
          this.localValue.gecikme_tazminati_mi = false
        }
      }

      if (this.localValue.id){
        if (String(this.localValue.aylik_nafaka_tutari) !== String(this.originalAylikTutar)) {
          this.showConfirmDialog = true;
          return;
        }
        if (this.localValue.elle_faiz_oran_mi) {
          if (this.localValue.elle_faiz_mi && this.localValue.takip_sonrasi_faiz_turu) {
            const faizTuruId = await this.$helper.saveFaizTuru(this.localValue.takip_sonrasi_faiz_turu, this.$route.params.id);
            this.localValue.takip_oncesi_faiz_turu_id = faizTuruId;
            this.localValue.takip_sonrasi_faiz_turu_id = faizTuruId;
          } else {
            this.localValue.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(this.localValue.takip_oncesi_faiz_turu, this.$route.params.id);
            this.localValue.takip_sonrasi_faiz_turu_id = this.localValue.takip_oncesi_faiz_turu_id;
          }
        }
        await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id,this.localValue);
        this.kuruAlacagaYansit();
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }else{
        await this.$http.post('/api/v1/alacak/' + this.alacak.id + '/alacak-kalemi',this.localValue);
        this.kuruAlacagaYansit();
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }
    }else{
      this.$emit("addAsilAlacak",this.localValue);
      this.$emit("onSuccess");
    }
  }

  async confirmUpdate(){
    this.localValue.is_devam_eden_aylar = this.devamEdenAylarIcinGecerli;
    this.localValue.update_alacak_tutar = true;

    if (this.localValue.elle_faiz_oran_mi) {
      if (this.localValue.elle_faiz_mi && this.localValue.takip_sonrasi_faiz_turu) {
        const faizTuruId = await this.$helper.saveFaizTuru(this.localValue.takip_sonrasi_faiz_turu, this.$route.params.id);
        this.localValue.takip_oncesi_faiz_turu_id = faizTuruId;
        this.localValue.takip_sonrasi_faiz_turu_id = faizTuruId;
      } else {
        this.localValue.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(this.localValue.takip_oncesi_faiz_turu, this.$route.params.id);
        this.localValue.takip_sonrasi_faiz_turu_id = this.localValue.takip_oncesi_faiz_turu_id;
      }
    }

    await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id, this.localValue);
    this.kuruAlacagaYansit();
    this.originalAylikTutar = this.localValue.aylik_nafaka_tutari;
    this.showConfirmDialog = false;
    this.devamEdenAylarIcinGecerli = true;
    this.localValue.update_alacak_tutar = false;
    this.$emit("addAsilAlacak", this.localValue);
    this.$emit("onSuccess");
  }

  async cancelUpdate(){
    this.localValue.is_devam_eden_aylar = false;
    this.localValue.update_alacak_tutar = false;

    if (this.localValue.elle_faiz_oran_mi) {
      if (this.localValue.elle_faiz_mi && this.localValue.takip_sonrasi_faiz_turu) {
        const faizTuruId = await this.$helper.saveFaizTuru(this.localValue.takip_sonrasi_faiz_turu, this.$route.params.id);
        this.localValue.takip_oncesi_faiz_turu_id = faizTuruId;
        this.localValue.takip_sonrasi_faiz_turu_id = faizTuruId;
      } else {
        this.localValue.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(this.localValue.takip_oncesi_faiz_turu, this.$route.params.id);
        this.localValue.takip_sonrasi_faiz_turu_id = this.localValue.takip_oncesi_faiz_turu_id;
      }
    }

    await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id, this.localValue);
    this.kuruAlacagaYansit();
    this.originalAylikTutar = this.localValue.aylik_nafaka_tutari;
    this.showConfirmDialog = false;
    this.devamEdenAylarIcinGecerli = true;
    this.$emit("addAsilAlacak", this.localValue);
    this.$emit("onSuccess");
  }

  /*get nafakaLabel() {
    if (this.localValue.alacak_kalemi_turu?.id == AlacakKalemiTuru.yargilamaGideri)
      return 'Yargılama Gideri Tutarı';
    else if (this.localValue.alacak_kalemi_turu?.id == AlacakKalemiTuru.mahkemeVekaletUcreti)
      return 'Vekalet Ücreti Tutarı'
    else
      return 'Aylık Nafaka Tutarı'
  }*/

  get isIlamliTakip(): boolean {
    return this.$helper.isIlamliTakipFromTakipStore();
  }

  get tarih() {
    if (this.localValue.vade_tarihi) {
      return this.localValue.vade_tarihi;
    } else if (this.localValue.ibraz_tarihi) {
      return this.localValue.ibraz_tarihi;
    }
  }

  @Watch('localValue.para_birimi_id')
  onParaBirimiIdChange() {
    this.addParaBirimi();
  }

  addParaBirimi() {
    if (this.localValue.takip_tarihli_kurlar &&
        this.localValue.para_birimi_id != ParaBirimi.TRY &&
        !this.localValue.takip_tarihli_kurlar.find((kur:any) => kur.para_birimi_id == this.localValue.para_birimi_id)) {
      let kur = new TakipTarihliKurEntity();
      kur.para_birimi = this.localValue.para_birimi;
      kur.para_birimi_id = this.localValue.para_birimi_id;
      kur.tutar = null;
      this.localValue.takip_tarihli_kurlar.push(kur);
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY) {
      delete this.localValue.doviz_kur_tarihi;
      this.localValue?.asil_alacaklar?.forEach((asilAlacak: AlacakKalemiEntity) => {
        asilAlacak.para_birimi_id = this.paraBirimi.TRY;
        asilAlacak.para_birimi = this.paraBirimleri.find((paraBirimi: any) => (paraBirimi.id == this.paraBirimi.TRY));
      });
    } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {
      this.localValue?.asil_alacaklar?.forEach((asilAlacak: AlacakKalemiEntity) => {
        asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
        asilAlacak.para_birimi = this.localValue.para_birimi;
      });
    }
    this.addParaBirimi();
    this.input();
  }

  get isHideButtons() {
    return this.hideButtons || this.hideButtons === "";
  }

  get aciklama() {
    if (this.localValue.alacak_kalemi_turu) {
      if ((this.localValue.alacak_kalemi_turu.id == AlacakKalemiTuru.istirakNafakasi || this.localValue.alacak_kalemi_turu.id == AlacakKalemiTuru.yoksullukNafakasi) && this.localValue.cocuk_isim) {
        return this.localValue.cocuk_isim + " için " + this.localValue.alacak_kalemi_turu.isim + " Alacağı";
      }
      return this.localValue.alacak_kalemi_turu.isim + " Alacağı";
    }
  }

  get alacakKalemiRules() {
    if (this.localValue.aciklama) {
      if (this.localValue.aciklama.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return true;
  }

  private updateParaBirimiState() {
    const paraBirimiId = this.alacak.para_birimi_id;
    const dovizKurTarihi = this.alacak.doviz_kur_tarihi;
    const isForeignCurrency = paraBirimiId !== this.paraBirimi.TRY;
    this.readonlyParaBirimi = false;
    if (!isForeignCurrency) {
      this.localValue.para_birimi_id = this.paraBirimi.TRY;
      return;
    }
    switch (dovizKurTarihi) {
      case DovizTakipSekli.tahsilat:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
      case DovizTakipSekli.vade:
      case DovizTakipSekli.takip:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
    }
  }

  @Watch('alacak.para_birimi_id')
  onAlacakParaBirimiChange() {
    this.updateParaBirimiState();
  }

  @Watch('alacak.doviz_kur_tarihi')
  onAlacakDovizKurTarihiChange() {
    this.updateParaBirimiState();
    this.input();
  }

  @Watch("tarih")
  onVadeTarihiChange() {
    this.localValue.faiz_baslangic_tarihi = this.tarih;
  }

  @Watch("aciklama")
  onAciklamaChange() {
    this.localValue.aciklama = this.aciklama;
    this.input();
  }

  // ObjectInputMixin kancası: mount'ta ve ebeveyn `value`yu her DEĞİŞTİRDİĞİNDE çalışır — yani
  // kayıtlı kalemin verisi geldiğinde (FormDialog içeriği her açılışta yeniden kurulur; o an
  // `value` bir önceki açılışın bayat verisidir, gerçek kalem alacakKalemiDetay GET'i dönünce gelir).
  //
  // Kullanıcı yazarken ÇALIŞMAMASI şart (Aylık kutusu geçici boşaltılırsa aşağıdaki koşul yeniden
  // doğar, yazılan talep edilen tutar Aylık kutusuna kaçar). Bugünkü kullanımlarda sağlanıyor:
  //  - kayıtlı kalem (id var) yalnız düzenleme dialoglarında açılıyor ve oradaki
  //    `v-model="localValue.id?alacakKalemiDetayData:item"` ifadesi atanabilir değil — Vue 2 onu
  //    ebeveyn alacağına `$set(localValue, "id?alacakKalemiDetayData:item", …)` diye derler,
  //    `value` hiç geri yazılmaz;
  //  - geri yazan tek yer olan sihirbazlardaki kalemin (`asil_alacaklar[0]`) id'si yok.
  // Id'li bir kalemi iki yönlü v-model ile bağlayan yeni bir kullanım eklenirse bu varsayım bozulur.
  //
  // Taban aylığı izliyorsa (API: aylik_nafaka_tutari boş) tutar "Aylık" kutusuna taşınır,
  // "Talep Edilen" boş gösterilir — gerekçesi nafakaTutarlariniFormaAyir'da.
  protected onValueChange() {
    if (!this.localValue || !this.localValue.id) {
      return;
    }
    const ayrik = nafakaTutarlariniFormaAyir(this.localValue);
    this.$set(this.localValue, 'aylik_nafaka_tutari', ayrik.aylik_nafaka_tutari);
    this.$set(this.localValue, 'tutar', ayrik.tutar);
    this.$set(this.localValue, 'talep_edilen_nafaka_tutari', ayrik.talep_edilen_nafaka_tutari);
    this.originalAylikTutar = ayrik.aylik_nafaka_tutari;
  }

  // Kayıtlı alacakta kalemin kuru kaydedildi: alacak formu eski değeri gösterip Kaydet'inde DB'ye geri yazmasın.
  // Yalnız kullanıcı kur kutusunu değiştirdiyse: düzenleme diyaloğu GET yanıtıyla dolar, dokunulmamış (DB'deki)
  // kur alacak ekranındaki kaydedilmemiş düzenlemeyi ezmesin.
  kuruAlacagaYansit() {
    if (!this.kurElleDegisti) {
      return;
    }
    alacakKurunuEsitle(this.alacak.takip_tarihli_kurlar, this.localValue.takip_tarihli_kurlar, this.localValue.para_birimi_id);
  }

  // Kaydedilmemiş alacakta yeni kalem alacağın kur listesini paylaşır (takip + para birimi başına tek kur);
  // ayrı liste ikinci kur satırı açıyordu. Liste kalemden sonra gelebilir, o yüzden izleyici de var.
  // Aynı listeyse çıkılır: input() ebeveyni yeniden kurup izleyiciyi tekrar tetikler, korumasız döngü olur.
  @Watch('alacak.takip_tarihli_kurlar')
  alacakKurlariniPaylas() {
    const ortak = this.alacak?.takip_tarihli_kurlar;
    if (this.localValue.id || this.alacak?.id || !Array.isArray(ortak) || this.localValue.takip_tarihli_kurlar === ortak) {
      return;
    }
    // Yeni nesne: mounted'taki boş liste düz atandı (reaktif değil), $set onu yalnız üzerine yazardı.
    this.localValue = Object.assign({}, this.localValue, {takip_tarihli_kurlar: ortak});
    // Para birimi seçici asenkron dolar; boşken ortak listeye para birimsiz sahte satır düşerdi.
    if (this.localValue.para_birimi_id) {
      this.addParaBirimi();
    }
    this.input();
  }

  mounted() {
    if (this.localValue.id){
      this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    }else{
      this.localValue.takip_tarihli_kurlar = []
      this.alacakKurlariniPaylas();
    }
    if (!this.localValue.is_devam_eden_aylar) {
      this.localValue.is_devam_eden_aylar = true;
    }
    this.updateParaBirimiState();
  }


}
